/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface YearlyRatiosDto
 */
export interface YearlyRatiosDto {
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    marketCapitalization: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    enterpriseValue: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    peRatio: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    priceToSales: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    priceToBook: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    priceTangibleBook: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    priceToFreeCashFlow: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    fcfYield: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    debtToEquity: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    roic: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    roce: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearlyRatiosDto
     */
    roe: number | null;
}

export function YearlyRatiosDtoFromJSON(json: any): YearlyRatiosDto {
    return YearlyRatiosDtoFromJSONTyped(json, false);
}

export function YearlyRatiosDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): YearlyRatiosDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'marketCapitalization': json['marketCapitalization'],
        'enterpriseValue': json['enterpriseValue'],
        'peRatio': json['peRatio'],
        'priceToSales': json['priceToSales'],
        'priceToBook': json['priceToBook'],
        'priceTangibleBook': json['priceTangibleBook'],
        'priceToFreeCashFlow': json['priceToFreeCashFlow'],
        'fcfYield': json['fcfYield'],
        'debtToEquity': json['debtToEquity'],
        'roic': json['roic'],
        'roce': json['roce'],
        'roe': json['roe'],
    };
}

export function YearlyRatiosDtoToJSON(value?: YearlyRatiosDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'marketCapitalization': value.marketCapitalization,
        'enterpriseValue': value.enterpriseValue,
        'peRatio': value.peRatio,
        'priceToSales': value.priceToSales,
        'priceToBook': value.priceToBook,
        'priceTangibleBook': value.priceTangibleBook,
        'priceToFreeCashFlow': value.priceToFreeCashFlow,
        'fcfYield': value.fcfYield,
        'debtToEquity': value.debtToEquity,
        'roic': value.roic,
        'roce': value.roce,
        'roe': value.roe,
    };
}

